module.exports = __webpack_public_path__ + "img/design2.9c523b7a.png";